import { use_slice_generation } from '@/hooks/store/use_slices';
import { DTO__ml_asset_lora_tag_frequency } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset_lora_tag_frequency';
import { useMemo } from 'react';
import { HOOK__ml_asset_lora_get_enabled_and_non_zero_weight } from './HOOK__ml_asset_lora_get_enabled_and_non_zero_weight';

//returns map of lora hash -> tag frequency[]
export function HOOK__get_lora_tags(node_id: string) {
  const { generation_current } = use_slice_generation(['generation_current']);

  const ml_assets_loras = HOOK__ml_asset_lora_get_enabled_and_non_zero_weight(node_id);

  const out = useMemo(() => get_lora_tags(), [node_id, ml_assets_loras, generation_current]);

  function get_lora_tags() {
    //key - lora hash
    let out_local = new Map<string, DTO__ml_asset_lora_tag_frequency[]>();

    for (let ml_asset_lora of ml_assets_loras) {
      let lora_tags = ml_asset_lora.config.get_lora__tag_frequency();

      for (let lora_tag of lora_tags) {
        out_local.add_item_to_array(ml_asset_lora.hash_sha256, lora_tag);
      }
    }

    return out_local;
  }

  return out;
}
